'use strict'
import M from 'moment'
export default {
    install(Vue, options) {
        Vue.mixin({
            methods: {
                /**
                 * 验证类型
                 * 参数bol是数据类型
                 */
                isTrue(bol) {
                    if (bol === null || bol === '' || bol === 'null' || bol === 'undefined' || bol === undefined || bol === isNaN || bol === 'isNaN' || bol === 0) {
                        return false
                    } else {
                        return true
                    }
                },
                /**
                 * 把秒数转化为天、时、分、秒
                 * 参数value是秒数
                 */
                formatSeconds(value) {
                    var secondTime = parseInt(value) // 秒
                    var minuteTime = 0 // 分
                    var hourTime = 0 // 小时
                    var dayTime = 0 // 天
                    var result = ''
                    if (value < 60) {
                        result = secondTime + '秒'
                    } else {
                        if (secondTime >= 60) { // 如果秒数大于60，将秒数转换成整数
                            // 获取分钟，除以60取整数，得到整数分钟
                            minuteTime = parseInt(secondTime / 60)
                            // 获取秒数，秒数取佘，得到整数秒数
                            secondTime = parseInt(secondTime % 60)
                            // 如果分钟大于60，将分钟转换成小时
                            if (minuteTime >= 60) {
                                // 获取小时，获取分钟除以60，得到整数小时
                                hourTime = parseInt(minuteTime / 60)
                                // 获取小时后取佘的分，获取分钟除以60取佘的分
                                minuteTime = parseInt(minuteTime % 60)
                                if (hourTime >= 24) {
                                    // 获取天数， 获取小时除以24，得到整数天
                                    dayTime = parseInt(hourTime / 24)
                                    // 获取小时后取余小时，获取分钟除以24取余的分；
                                    hourTime = parseInt(hourTime % 24)
                                }
                            }
                        }
                        if (secondTime > 0) {
                            secondTime = parseInt(secondTime) >= 10 ? secondTime : '0' + secondTime
                            result = '' + secondTime + '秒'
                        }
                        if (minuteTime > 0) {
                            minuteTime = parseInt(minuteTime) >= 10 ? minuteTime : '0' + minuteTime
                            result = '' + minuteTime + '分' + result
                        }
                        if (hourTime > 0) {
                            result = '' + parseInt(hourTime) + '小时' + result
                        }
                        if (dayTime > 0) {
                            result = '' + parseInt(dayTime) + '天' + result
                        }
                    }
                    return result
                 },
                /**
                 * 把阿拉伯数字转大写
                 * 参数value是秒数
                 */
                 changeNumToHan(num) {
                    var arr1 = new Array('零', '一', '二', '三', '四', '五', '六', '七', '八', '九');
                    var arr2 = new Array('', '十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千','万', '十', '百', '千','亿');//可继续追加更高位转换值
                        if(!num || isNaN(num)){
                          return "零";
                        }
                    var english = num.toString().split("")
                    var result = "";
                    for (var i = 0; i < english.length; i++) {
                        var des_i = english.length - 1 - i;//倒序排列设值
                        result = arr2[i] + result;
                        var arr1_index = english[des_i];
                        result = arr1[arr1_index] + result;
                     }
                     //将【零千、零百】换成【零】 【十零】换成【十】
                     result = result.replace(/零(千|百|十)/g, '零').replace(/十零/g, '十');
                     //合并中间多个零为一个零
                     result = result.replace(/零+/g, '零');
                     //将【零亿】换成【亿】【零万】换成【万】
                     result = result.replace(/零亿/g, '亿').replace(/零万/g, '万');
                     //将【亿万】换成【亿】
                     result = result.replace(/亿万/g, '亿');
                     //移除末尾的零
                     result = result.replace(/零+$/, '')
                     //将【零一十】换成【零十】
                     //result = result.replace(/零一十/g, '零十');//貌似正规读法是零一十
                     //将【一十】换成【十】
                     result = result.replace(/^一十/g, '十')
                     return result;
                },
                /*
                * 封装公共金额转化大小写文件
                */ 
                NumberToChinese(n){
                    if(n){
                    var fraction = ['角', '分'];
                    var digit = [
                        '零', '壹', '贰', '叁', '肆',
                        '伍', '陆', '柒', '捌', '玖'
                    ];
                    var unit = [
                        ['元', '万', '亿'],
                        ['', '拾', '佰', '仟']
                    ];
                    var head = n < 0 ? '负' : '';
                    n = Math.abs(n);
                    var s = '';
                    for (var i = 0; i < fraction.length; i++) {
                        s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '');
                    }
                    s = s || '整';
                    n = Math.floor(n);
                    for (var i = 0; i < unit[0].length && n > 0; i++) {
                        var p = '';
                        for (var j = 0; j < unit[1].length && n > 0; j++) {
                            p = digit[n % 10] + unit[1][j] + p;
                            n = Math.floor(n / 10);
                        }
                        s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s;
                    }
                    return head + s.replace(/(零.)*零元/, '元')
                        .replace(/(零.)+/g, '零')
                        .replace(/^整$/, '零元整')
                    }  
                },
                 /**
                 * 获取今天开始结束时间
                 */     
                getCurrentDay(){
                    let date = []
                    let start = M(M().format('YYYY-MM-DD 00:00:00')).valueOf() 
                    let end = M(M().format('YYYY-MM-DD HH:mm:ss')).valueOf() 
                    date.push(start)
                    date.push(end)
                    return date
                },
                /**
                 * 获取昨天开始结束时间
                 */     
                 getYesterDay(){
                    let date = []
                    let start = M(M().add(-1, 'days').format('YYYY-MM-DD 00:00:00')).valueOf() 
                    let end = M(M().add(-1, 'days').format('YYYY-MM-DD 23:59:59')).valueOf() 
                    date.push(start)
                    date.push(end)
                    return date
                },
                /**
                 * 获取明天开始结束时间
                 */     
                getTomorrowDay(){
                    let date = []
                    let start = M(M().add(+1, 'days').format('YYYY-MM-DD 00:00:00')).valueOf() 
                    let end = M(M().add(+1, 'days').format('YYYY-MM-DD 23:59:59')).valueOf() 
                    date.push(start)
                    date.push(end)
                    return date
                },
                /**
                 * 获取明、后天开始结束时间
                 */     
                getAfterTomorrowDay(){
                    let date = []
                    let start = M(M().add(+2, 'days').format('YYYY-MM-DD 00:00:00')).valueOf() 
                    let end = M(M().add(+2, 'days').format('YYYY-MM-DD 23:59:59')).valueOf() 
                    date.push(start)
                    date.push(end)
                    return date
                },
                /**
                 * 获取前天开始结束时间
                 */     
                 getBeforeYesterDay(){
                    let date = []
                    let start = M(M().add(-2, 'days').format('YYYY-MM-DD 00:00:00')).valueOf() 
                    let end = M(M().add(-2, 'days').format('YYYY-MM-DD 23:59:59')).valueOf() 
                    date.push(start)
                    date.push(end)
                    return date
                },
                 /**
                 * 获取本周开始结束时间
                 */     
                  getCurrWeekDays(){
                    let date = []
                    let start = M(M().weekday(1).format('YYYY-MM-DD 00:00:00')).valueOf() // 周一日期
                    let end = M(M().format('YYYY-MM-DD HH:mm:ss')).valueOf()  // 现在
                    date.push(start)
                    date.push(end)
                    return date
                },
                /**
                 * 获取上周开始结束时间
                 */     
                 getLastWeekDays(){
                    let date = []
                    let weekOfday = parseInt(M().format('E')) // 计算今天是这周第几天
                    let start = M(M().subtract(weekOfday + 7 - 1, 'days').format('YYYY-MM-DD 00:00:00')).valueOf() //上周一
                    let end = M(M().subtract(weekOfday, 'days').format('YYYY-MM-DD 23:59:59')).valueOf() //上周末
                    date.push(start)
                    date.push(end)
                    return date
                },
                /**
                 * 获取本月开始结束时间
                 */  
                getCurrMonthDays() {
                    let date = [] 
                    let start = M().add('month', 0).format('YYYY-MM') + '-01'
                    let start_1 = M(M(start).format('YYYY-MM-DD HH:mm:ss')).valueOf() 
                    let end = M(M(start).add('month', 1).add('days', -1).format('YYYY-MM-DD 23:59:59')).valueOf()
                    date.push(start_1)
                    date.push(end)
                    return date
                },
                /**
                 * 获取上一个月的开始结束时间
                 */  
                 getLastMonthDays() {
                    let date = []
                    let start = M(M().subtract('month', 1).format('YYYY-MM') + '-01').valueOf()
                    let end = M(M(start).subtract('month', -1).add('days', -1).format('YYYY-MM-DD 23:59:59')).valueOf()
                    date.push(start)
                    date.push(end)
                    return date
                },
                /**
                 * 获取下一个月的开始结束时间
                 */  
                getNextMonthDays() {
                    let date = []
                    let start = M(M().subtract('month', 1).format('YYYY-MM') + '-01').valueOf()
                    let end = M(M(start).subtract('month', +1).add('days', +1).format('YYYY-MM-DD 23:59:59')).valueOf()
                    date.push(start)
                    date.push(end)
                    return date
                },
                /**
                 * 获取最近三天天的开始结束时间
                 */  
                 getLast3Days() {
                    let date = []
                    let start = M(M().subtract('days', 3).format('YYYY-MM-DD 00:00:00')).valueOf()
                    let end = M(M().subtract('days', 1).format('YYYY-MM-DD 23:59:59')).valueOf()
                    date.push(start)
                    date.push(end)
                    return date
                },
                /**
                 * 获取最近七天的开始结束时间
                 */  
                getLast7Days () {
                    let date = []
                    let start = M(M().subtract('days', 7).format('YYYY-MM-DD 00:00:00')).valueOf()
                    let end = M(M().subtract('days', 1).format('YYYY-MM-DD 23:59:59')).valueOf()
                    date.push(start)
                    date.push(end)
                    return date
                },
                /**
                 * 获取最近30天的开始结束时间
                 */  
                 getLast30Days() {
                    let date = []
                    let start = M(M().subtract('days', 30).format('YYYY-MM-DD 00:00:00')).valueOf()
                    let end = M(M().subtract('days', 1).format('YYYY-MM-DD 23:59:59')).valueOf()
                    date.push(start)
                    date.push(end)
                    return date
                }
           }
        })
    }
}



// WEBPACK FOOTER //
// ./src/utils/mixin.js